import { RECOMMENDATIONS, RECOMMENDATIONS_CLEAR_MSG, RECOMMENDATIONS_ERROR, RECOMMENDATIONS_HIDE_ERROR, RECOMMENDATIONS_MSG, RECOMMENDATIONS_START_LOADER, RECOMMENDATIONS_STOP_LOADER, } from "../interface/iRecommendation";
const initialState = {
    data: {
        recommendations: [],
    },
    recommendationLoader: false,
    message: {
        msg: null,
        show: false,
        icon: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
};
const recommendations = (state = initialState, action) => {
    switch (action.type) {
        case RECOMMENDATIONS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case RECOMMENDATIONS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case RECOMMENDATIONS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case RECOMMENDATIONS_START_LOADER:
            return Object.assign(Object.assign({}, state), { recommendationLoader: true });
        case RECOMMENDATIONS_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case RECOMMENDATIONS_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initialState.message });
        case RECOMMENDATIONS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { recommendationLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default recommendations;
